import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import MacbookAndIphone from '@propertypal/shared/src/resources/images/prime/prime-devices.png';
import { trackGaLink } from '@propertypal/shared/src/services/analytics';
import { GOLD } from '@propertypal/shared/src/styles/theme';
import { Property } from '@propertypal/shared/src/types';
import Link from 'next/link';
import React from 'react';
import Button from '../buttons/Button';
import FontAwesomeIcon from '../icons/FontAwesomeIcon';
import { Text } from '../typography';
import { Badge, Banner, CheckRow, Container, ImageWrapper } from './PromoteProperty.style';

interface PromotePropertyProps {
  property: Property;
}

const PromoteProperty: React.FC<PromotePropertyProps> = (props) => {
  return (
    <Container data-testid="promote-property-box">
      <div>
        <h3>
          Is this <b>your</b> home?
        </h3>

        <Text mt={15} mb={20} fontWeight="bold">
          Get more {props.property.saleType.key === 'rent' ? 'renters' : 'buyers'} looking at your home.
        </Text>

        <CheckRow>
          <FontAwesomeIcon icon={faCheck} color={GOLD} />
          <p>Priority placement over standard adverts</p>
        </CheckRow>

        <CheckRow>
          <FontAwesomeIcon icon={faCheck} color={GOLD} />
          <p>Receive more views and enquiries</p>
        </CheckRow>

        <CheckRow>
          <FontAwesomeIcon icon={faCheck} color={GOLD} />
          <p>Access to your home&apos;s performance stats</p>
        </CheckRow>

        <Link
          href={`/prime?propertyId=${props.property.pathId}`}
          onClick={trackGaLink('prime_advert_click', 'PDP Ad', 'PDP')}
          prefetch={false}
        >
          <Button containerStyle={{ maxWidth: 320, marginTop: 20 }} color={GOLD}>
            Upgrade to PropertyPal Prime
          </Button>
        </Link>
      </div>

      <ImageWrapper>
        <img src={MacbookAndIphone.src} alt="PropertyPal Example Ads" />
        <Banner>PROPERTYPAL PRIME</Banner>
        <Badge>
          <p>
            Get up to <span>80% more</span> enquiries
          </p>
        </Badge>
      </ImageWrapper>
    </Container>
  );
};

export default PromoteProperty;
